import axios from "axios";

export default {
  namespaced: true,
  state: {
    updateImg: Math.floor(Math.random() * 100),
    statusImg: [],
    datosImg: [],
    codigo: ""
  },
  mutations: {
    set_statusImg(state, data) {
      state.statusImg = data
    },
    set_datosImg(state, data){
      state.datosImg = data
    },
    ChrEsp(state, data) {
      const chrSplit = data.split("")
      let newChr = ""

      chrSplit.forEach(x => {
        if (x === "/") newChr += "-"
        else if (x === ".") newChr += "-"
        else newChr += x
      })

      state.codigo = newChr
    }

  },
  actions: {
    GuardarImg: async ({rootState, state, dispatch, commit}, param) => {
      let resp
      let arch = ""
      commit("ChrEsp",param.codigo)
      const options = {
        headers: {
          "Content-Type": "multipart/form-data",
        }
      }
      try {
        await dispatch("DatosImg", {
          tipo: param.tipo,
          codigo: state.codigo,
          categoria: param.categoria,
          archivo: param.archivo
        })
        const { archivo } = state.datosImg[0]
        arch = archivo

        const formData = new FormData()
        formData.append('tipo', param.tipo)
        formData.append('codigo', state.codigo)
        formData.append('categoria', param.categoria)
        formData.append('archivo', param.FILE, param.FILE.name)

        if (arch !== "") {
          resp = await axios.put(`${rootState.domoapi2_img}${arch}`, formData, options)
        } else {
          resp = await axios.post(`${rootState.domoapi2_img}`, formData, options)
        }
        if (resp.status === 200) {
          const { data } = resp
          commit("set_statusImg", data)
        }
      } catch (error) {
        console.log(error)
      }
    },
    DatosImg: async ({rootState, commit}, param) => {
      try {
        const resp = await axios.post(
          `${rootState.domoapi2_img}Datos`, param)
        
        if (resp.status === 200) {
          const { data } = resp
          if (data.length !== 0) {
            commit("set_datosImg", data)
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    EliminarImg: async ({rootState, commit}, param) => {
      try {
        const resp = await axios({
          method: 'delete',
          url: `${rootState.domoapi2_img}`,
          data: param
        })
        if (resp.status === 200) {
          const { data } = resp
          commit("set_datosImg", data)
        }
      } catch (error) {
        console.log(error)
      }
    }
  },
}